export default "__VITE_ASSET__BDiKnh6Q__"